import React from 'react';
import { useNavigate } from 'react-router-dom';

const VOID_BG = '#080810';
const CYAN = '#00FFE5';
const ICE = '#E8F4FF';
const MONO = "'JetBrains Mono', 'Courier New', monospace";
const ORBITRON = "'Orbitron', monospace";

const LoginHeader = () => {
  const navigate = useNavigate();

  return (
    <header className="fixed top-0 left-0 right-0 z-40" style={{ background: 'rgba(8,8,16,0.95)', backdropFilter: 'blur(12px)', borderBottom: '1px solid rgba(0,255,229,0.2)' }}>
      <div className="flex items-center justify-between h-16 px-4 lg:px-6">
        <button
          onClick={() => navigate('/')}
          className="flex items-center space-x-3 transition-opacity hover:opacity-80"
          style={{ background: 'none', border: 'none', cursor: 'pointer' }}
        >
          <span style={{ fontFamily: ORBITRON, fontWeight: 700, fontSize: '1.1rem', color: ICE }}>
            &lt; RECALL<span style={{ color: CYAN }}>CORE</span>™
          </span>
        </button>
        <div className="flex items-center space-x-4">
          <button
            onClick={() => navigate('/user-registration')}
            style={{ color: CYAN, fontFamily: MONO, fontSize: '0.7rem', letterSpacing: '0.1em', textTransform: 'uppercase', background: 'none', border: `1px solid rgba(0,255,229,0.4)`, padding: '6px 14px', cursor: 'pointer', transition: 'border-color 0.2s' }}
            onMouseEnter={e => e.currentTarget.style.borderColor = CYAN}
            onMouseLeave={e => e.currentTarget.style.borderColor = 'rgba(0,255,229,0.4)'}
          >
            CREATE ACCOUNT
          </button>
        </div>
      </div>
    </header>
  );
};

export default LoginHeader;